/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_deposit_modal_instruction_2 = /** @type {(inputs: {}) => string} */ () => {
	return `Los depósitos pueden tardar entre 1 y 5 minutos en procesarse`
};

const en_cards_deposit_modal_instruction_2 = /** @type {(inputs: {}) => string} */ () => {
	return `Deposits can take between 1 and 5 minutes to process`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_deposit_modal_instruction_2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_deposit_modal_instruction_2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_deposit_modal_instruction_2", locale)
	if (locale === "es") return es_cards_deposit_modal_instruction_2(inputs)
	return en_cards_deposit_modal_instruction_2(inputs)
};
export { cards_deposit_modal_instruction_2 as "cards.deposit_modal.instruction_2" }